module.exports = __webpack_public_path__ + "img/GazelEnergie_120X35.d54626e7.png";